import { ONBOARDING_PAGE_NS } from './i18n';
import { useTranslation } from 'react-i18next';

export const useIndustryOptions = () => {
  const { t } = useTranslation(ONBOARDING_PAGE_NS);

  const industryList = [
    t('industries.technology'),
    t('industries.goods'),
    t('industries.food'),
    t('industries.healthcare'),
    t('industries.construction'),
    t('industries.finance'),
    t('industries.arts'),
    t('industries.transportation'),
    t('industries.education'),
    t('industries.agriculture'),
    t('industries.manufacturing'),
    t('industries.energy'),
    t('industries.services'),
    t('industries.sector'),
    t('industries.other'),
  ];

  return industryList;
};
